module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_POZYCZKA.96a103b5.mp3";